import PropTypes from 'prop-types';
import axios from 'axios';
import i18n from '../../../../services/i18n';
import Notifications from '../../../../services/notifications';

export const FILTER = {
  SEARCH: 'search',
  DATE: 'date',
  BUYER_TYPE: 'buyerType',
};

export const OPPORTUNITIES_STATUS = {
  PENDING: 'pending',
  APPROVED: 'approved',
  PAID: 'paid',
  REJECTED: 'rejected',
  QUALIFICATION: 'qualification',
  REFERENCES: 'references',
  LEADS: 'leads',
  PROPOSAL: 'proposal',
  COMMERCIAL_VERIFICATION: 'commercial_verification',
  WAITING_FOR_ENCODING: 'waiting_for_encoding',
  ACTIVATION: 'activation',
  PARTIALLY_WON: 'partially_won',
};

export const getOpportunityStatusTranslation = status => {
  switch (status) {
    case OPPORTUNITIES_STATUS.PENDING:
      return i18n.__('status.negotiation');
    default:
      return i18n.__(`status.${status}`);
  }
};

export const OPPORTUNITIES_STATUSES = [
  {
    status: OPPORTUNITIES_STATUS.QUALIFICATION,
    text: 'status.qualification',
    order: 1,
  },
  {
    status: OPPORTUNITIES_STATUS.REFERENCES,
    text: 'status.references',
    order: 2,
  },
  { status: OPPORTUNITIES_STATUS.LEADS, text: 'status.leads', order: 3 },
  { status: OPPORTUNITIES_STATUS.PROPOSAL, text: 'status.proposal', order: 4 },
  {
    status: OPPORTUNITIES_STATUS.COMMERCIAL_VERIFICATION,
    text: 'status.commercial_verification',
    order: 5,
  },
  {
    status: OPPORTUNITIES_STATUS.PENDING,
    text: 'status.negotiation',
    order: 6,
  },
  {
    status: OPPORTUNITIES_STATUS.APPROVED,
    text: 'status.opportunity_approved',
    order: 7,
  },
  {
    status: OPPORTUNITIES_STATUS.WAITING_FOR_ENCODING,
    text: 'status.waiting_for_encoding',
    order: 8,
  },
  {
    status: OPPORTUNITIES_STATUS.ACTIVATION,
    text: 'status.activation',
    order: 9,
  },
  {
    status: OPPORTUNITIES_STATUS.PARTIALLY_WON,
    text: 'status.partially_won',
    order: 10,
  },
  {
    status: OPPORTUNITIES_STATUS.PAID,
    text: 'status.opportunity_paid',
    order: 11,
  },
  {
    status: OPPORTUNITIES_STATUS.REJECTED,
    text: 'status.opportunity_rejected',
    order: 12,
  },
];
export const OPPORTUNITY_HISTORY_TYPES = [
  { type: 'status_change', text: 'opportunity.status.changed', order: 1 },
  { type: 'payment_method_change', text: 'payment_method_change', order: 2 },
];

const propType = {
  search: PropTypes.string,
  startDate: PropTypes.number,
  endDate: PropTypes.number,
  buyerType: PropTypes.string,
};

const defaultProp = {
  search: null,
  startDate: null,
  endDate: null,
  buyerType: null,
};

export const isAbleToSendOfferEmail = status =>
  !Object.values([
    OPPORTUNITIES_STATUS.APPROVED,
    OPPORTUNITIES_STATUS.WAITING_FOR_ENCODING,
    OPPORTUNITIES_STATUS.ACTIVATION,
    OPPORTUNITIES_STATUS.PARTIALLY_WON,
    OPPORTUNITIES_STATUS.PAID,
  ]).includes(status);

export const sendOfferEmail = async (
  _csrf,
  opportunityIds,
  onLoading = null,
) => {
  try {
    if (onLoading) {
      onLoading(true);
    }

    await axios.post(
      '/api/market/opportunity/sendEmails',
      { opportunityIds },
      {
        headers: {
          'Accept-Version': '1.0.0',
          'X-Gamification-API': 'Games',
          'X-CSRF-Token': _csrf,
          _csrf,
        },
      },
    );
    Notifications.showNotificationSuccess(
      i18n.__('success'),
      i18n.__('send.offer.email.success'),
    );
  } catch (e) {
    Notifications.showErrorFromRequest(e, 'send.offer.email.error');
  } finally {
    if (onLoading) {
      onLoading(false);
    }
  }
};

export default { propType, defaultProp };
